import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export function useItemLinks(itemId: string) {
  return useQuery({
    queryKey: ['itemLinks', itemId],
    queryFn: () => apiClient.getItemLinks(itemId),
    enabled: !!itemId,
  });
}

export function useCreateItemLink() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ itemId, data }: { itemId: string; data: { peripheralItemId: string; linkType: string; notes?: string } }) =>
      apiClient.createItemLink(itemId, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['itemLinks', variables.itemId] });
    },
  });
}

export function useDeleteItemLink() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ itemId, linkId }: { itemId: string; linkId: string }) =>
      apiClient.deleteItemLink(itemId, linkId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['itemLinks'] });
    },
  });
}

export function useDeletePreflight(itemId: string) {
  return useQuery({
    queryKey: ['deletePreflight', itemId],
    queryFn: () => apiClient.getDeletePreflight(itemId),
    enabled: false, // Only fetch on demand
  });
}
